import { styled } from '@mui/material/styles'
import Divider from '@mui/material/Divider'
import { youShallNotPass } from 'lib/helpers/youShallNotPass/youShallNotPass'

interface SeparatorProps {
  side?: 'left' | 'right'
}

export const Separator = styled(Divider, {
  shouldForwardProp: youShallNotPass('side'),
})<SeparatorProps>(({ theme, side }) => ({
  flexGrow: 1,
  borderColor: theme.tokens.ThemeColorCommonOutline,
  ...(side === 'left' && {
    marginRight: theme.spacing(2),
  }),
  ...(side === 'right' && {
    marginLeft: theme.spacing(2),
  }),
}))
